import {
  IFavoriteProjectsApi,
  IManagementBackendClient,
  IProjectsApi,
  IUsersApi,
} from "@lib/types";
import { BaseClient } from "../base-client";
import { FavoriteProjectsApi } from "./favorite-projects";
import { ProjectsApi } from "./projects";
import { UsersApi } from "./users";

export class ManagementBackendClient
  extends BaseClient
  implements IManagementBackendClient
{
  constructor(baseURL: string) {
    if (!baseURL) throw new Error("Base URL is required");

    super({
      baseURL,
      headers: {
        "Content-Type": "application/json",
      },
    });

    this.Users = new UsersApi(this._instance);
    this.Projects = new ProjectsApi(this._instance);
    this.FavoriteProjects = new FavoriteProjectsApi(this._instance);
  }

  public Users: IUsersApi;
  public Projects: IProjectsApi;
  public FavoriteProjects: IFavoriteProjectsApi;
}
